import React, { useState, useEffect } from 'react';

import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap';

import dateFormat from 'dateformat';

import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { SideTab } from '../Components/SideTab';
import AgentMarxTotal from '../Components/AgentMarxTotal';
import AgentMarxSingle from '../Components/AgentMarxSingle';

export default function MarxButton(props) {
  const [show, setShow] = useState(false);

  var userRepository = new MedicareProAPI.UserRepository();
  userRepository.setAccessToken(props.userAccessToken);

  var individualMarxRepository = new MedicareProAPI.IndMarxRepository();
  individualMarxRepository.setAccessToken(props.userAccessToken);

  var userFlagRepository = new MedicareProAPI.UserFlagRepository();
  userFlagRepository.setAccessToken(props.userAccessToken);

  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(props.userAccessToken);

  const [totalItems, setTotalItems] = useState(0);
  const [marxFlagTotals, setMarxFlagTotals] = useState(null);
  const [marxFlagTotalsFetching, setMarxFlagTotalsFetching] = useState(false);

  const [marxFlagViewing, setMarxFlagViewing] = useState(null);
  const [marxByFlagData, setMarxByFlagData] = useState(null);
  const [marxByFlagDataFetching, setMarxByFlagDataFetching] = useState(false);

  const [userFlagsData, setUserFlagsData] = useState([]);

  const flagLegend = {
    deceasedFlag: 'Deceased',
    currentPlanFlag: 'Current Plan',
    futurePlanFlag: 'Future Plan',
  };
  const cndImageUrl = 'https://medicareprocrm-cdn.s3.us-east-2.amazonaws.com/public/img/site/';

  const handleGetMarxTotals = () => {
    setMarxFlagTotalsFetching(true);
    setShow(true);
    const criteria = { user: props.userId, resolved: 0 };

    webAPI.getIndMarxsTotal({}, criteria).then((groups) => {
      let groupTotals = 0;
      groups.forEach((item) => {
        item.total > 0 ? groupTotals++ : '';
      });

      if (groupTotals > 0) {
        setMarxFlagTotals(groups);

        const process = groups.filter((item) => {
          return item.total > 0;
        });
        handleFetchMarxDataByFlag(process[0].flag);
        setMarxFlagViewing(process[0].flag);
      }
      setMarxFlagTotalsFetching(false);
    });
  };

  const handleFetchMarxDataByFlag = (flag) => {
    setMarxFlagViewing(flag);
    setMarxByFlagDataFetching(true);

    const criteria = { user: props.userId };
    criteria[flag] = 1;
    criteria['resolved'] = 0;
    const options = { include: ['ind', 'addresses', 'policies', 'spouse'] };

    individualMarxRepository.getIndMarxs(options, criteria).then((response) => {
      setMarxByFlagDataFetching(false);
      setMarxByFlagData(response.getItems());
      setMarxFlagViewing(flag);
    });
  };

  const handleRemoveMarxRecord = (flag, id) => {
    // Decrease the count for this flag type
    let _marxFlagTotals = [...marxFlagTotals];

    let flagIndex = _marxFlagTotals.findIndex((m) => m.flag === flag);

    _marxFlagTotals[flagIndex].total = _marxFlagTotals[flagIndex].total - 1;

    setMarxFlagTotals(_marxFlagTotals);

    // Remove the object from array
    let _marxByFlagData = [...marxByFlagData];

    _marxByFlagData = _marxByFlagData.filter((dataItem) => {
      return dataItem.id !== id;
    });

    setMarxByFlagData(_marxByFlagData);

    // If this flag type has no more records move to the next one
    if (_marxFlagTotals[flagIndex].total === 0) {
      const process = marxFlagTotals.filter((item) => {
        return item.total > 0;
      });

      if (process.length > 0) {
        handleFetchMarxDataByFlag(process[0].flag);
      }
    }

    // decrease the total items
    let _totalItems = totalItems - 1;

    setTotalItems(_totalItems);
  };

  const handleFetchUserFlags = () => {
    userFlagRepository.getUserFlags(props.userId).then((flags) => {
      setUserFlagsData(flags.getItems());
    });
  };

  const handleShow = () => {
    const process = marxFlagTotals.filter((item) => {
      return item.total > 0;
    });

    handleFetchMarxDataByFlag(process[0].flag);
    setMarxFlagViewing(process[0].flag);
    handleFetchUserFlags();
    setShow(true);
  };

  useEffect(() => {
    const criteria = { user: props.userId, resolved: 0 };

    webAPI.getIndMarxsTotal({}, criteria).then((groups) => {
      let groupTotals = 0;
      groups.forEach((item) => {
        if (item.total > 0) {
          groupTotals = groupTotals + item.total;
        }
      });

      if (groupTotals > 0) {
        setMarxFlagTotals(groups);
        setTotalItems(groupTotals);
      }
    });
  }, []);

  return (
    <>
      {totalItems > 0 && (
        <div className="alert alert-primary mt-3 py-2" style={{ fontSize: '11pt' }}>
          <img
            src={cndImageUrl + 'medizuesicon.png'}
            style={{ height: '20px' }}
            className="mr-2"
          ></img>
          You have unresolved enrollment reports.
          <div
            onClick={(e) => {
              handleShow();
            }}
            className={`ml-2 badge badge-primary cp`}
            style={{ fontSize: '9pt' }}
            title="Enrollment Reports"
          >
            View
          </div>
        </div>
      )}

      <SideTab
        size="md"
        position="right"
        title="Enrollment Reports"
        onClose={(e) => setShow(false)}
        show={show}
      >
        <div className="row mx-2">
          {marxFlagTotalsFetching && (
            <div className="mt-3 col-12 alert alert-info">
              <i className="fal fa-spinner fa-spin"></i> Getting reports results...
            </div>
          )}
          {totalItems === 0 && (
            <div className="col-12">
              <div className="mt-3 alert alert-info">
                <i className="far fa-thumbs-up mr-2"></i>
                All good! No report records that need your attention.
              </div>
            </div>
          )}

          {marxFlagTotals &&
            marxFlagTotals.map((item) => {
              return (
                <AgentMarxTotal
                  props={props}
                  key={item.flag}
                  item={item}
                  flag={marxFlagViewing}
                  onClick={handleFetchMarxDataByFlag}
                ></AgentMarxTotal>
              );
            })}
        </div>

        {['futurePlanFlag', 'currentPlanFlag'].includes(marxFlagViewing) &&
          marxByFlagData &&
          totalItems > 0 && (
            <div
              className="alert alert-sm alert-secondary mt-2 mx-2 mb-4"
              style={{ fontSize: '11pt' }}
            >
              <i className="far fa-info-circle"></i> The following records have enrolled in the
              plans listed below but aren't listed on their CRM profiles.
            </div>
          )}
        {marxFlagViewing == 'deceasedFlag' && marxByFlagData && totalItems > 0 && (
          <div
            className="alert alert-sm alert-secondary mt-2 mx-2 mb-4"
            style={{ fontSize: '11pt' }}
          >
            <i className="far fa-info-circle"></i> The following records are deceased.{' '}
          </div>
        )}

        {marxByFlagDataFetching && (
          <div className="col-12">
            <div className="mt-3 alert alert-info">
              <i className="far fa-spinner fa-spin mr-2"></i>
              Getting records...
            </div>
          </div>
        )}

        {marxFlagViewing && marxByFlagData && !marxByFlagDataFetching && (
          <div className="marxRecordsDiv">
            {marxByFlagData.map((item, index) => {
              return (
                <AgentMarxSingle
                  data={item}
                  flag={marxFlagViewing}
                  key={item.getId()}
                  index={index}
                  onClickRemoveMarxRecord={handleRemoveMarxRecord}
                  userAccessToken={props.userAccessToken}
                  userId={props.userId}
                  userFlagsData={userFlagsData}
                ></AgentMarxSingle>
              );
            })}
          </div>
        )}
      </SideTab>
    </>
  );
}
